export const Types = {
  SET_RECORD: 'SET_RECORD',
  SAVE_LIST_HOLIDAY : 'SAVE_LIST_HOLIDAY',
}
